import { dashboardMiddleware } from './handlers/dashboard/dashboard';
import { segmentsMiddleware } from './handlers/dashboard/segments';
import { identifyMiddleware } from './handlers/identify';
import { menuMiddleware } from './handlers/menu';
import { workflowMiddleware } from './handlers/workflow';
import { signUpMiddleware } from './handlers/sign-up';
import { signOutMiddleware } from './handlers/sign-out';
import { routerMiddleware } from './handlers/router';
import { dashboardReportsMiddleware } from './handlers/dashboard/reports';
import { clusterMiddleware } from './handlers/dashboard/cluster';
import { integrationsMiddleware } from './handlers/app-store/integrations/integrations';
import { partnershipsMiddlewares } from './handlers/app-store/partnerships/partnerships.middleware';
import { campaignsFilterMiddleware } from './handlers/dashboard/campaigns-filter';

export const analyticsMiddleware = [
    identifyMiddleware,
    clusterMiddleware,
    dashboardMiddleware,
    dashboardReportsMiddleware,
    menuMiddleware,
    signOutMiddleware,
    signUpMiddleware,
    segmentsMiddleware,
    workflowMiddleware,
    routerMiddleware,
    integrationsMiddleware,
    ...partnershipsMiddlewares,
    campaignsFilterMiddleware,
];
